/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-29 15:32:41
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-30 17:57:14
 * @FilePath: /unifyxp-v2-store-portal/src/components/Upload/ImageDisplaySetting/index.tsx
 */
import React, { useRef, useState } from 'react';
//import Cropper from 'react-cropper';
//import { ItemWrapper } from '@/src/components';
import {
  Modal, // Input,
  Button,
} from '@/src/components/Antd';
import styles from './style.less';
//import FocalPoint from '../FocalPoint';
import { Rnd } from 'react-rnd';
//import { useDebounceEffect } from 'ahooks';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const imageId = 'focus-point-img';
const tempId = 'imgId';

type Cooridnate = { x: number; y: number };
const focusPointSize = 40;

type Props = {
  visible: boolean;
  onCancel: () => void;
  onOk: ({ value, focalValue }: any) => void;
  src: string;
  value?: {
    leftTop: Cooridnate;
    rightTop: Cooridnate;
    leftBottom: Cooridnate;
    rightBottom: Cooridnate;
  };
  focalValue?: {
    x: number;
    y: number;
  };
};

// const PADDING = 23;
// const DEFAULT_OFFSET = 10;
export const FOCAL_POiNT_HALF_RADIUS = 20;
export const DIAMETER = FOCAL_POiNT_HALF_RADIUS * 2;
export const DEVIATION = 2;

function ImageDisplaySetting({
  visible,
  onCancel,
  onOk,
  value,
  focalValue,
  src,
}: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const [focalPoint, setFocalPoint] = useState({
    x: 0,
    y: 0,
  });
  const containerRef = useRef<any>();
  const zoomRatioRef = useRef<number>(1);
  const [w, setW] = React.useState(0);
  console.log('w', w);

  // const imageRef = useRef<any>({ left: 0, top: 0 });
  const focalPointRef = useRef<any>({ x: 0, y: 0 });
  const [
    cropBox, //setCropBox
  ] = useState({ width: 0, height: 0, x: 0, y: 0 });
  // const [containerOffset, setContainerOffset] = useState({ x: 0, y: 0 });
  //const ref = React.createRef<HTMLImageElement>();
  //onsole.log(222, focalPoint, cropBox);
  function imgOriginalSize() {
    function test() {
      const myImg: any = document.querySelector('#imgId');
      if (myImg) {
        const realWidth = myImg.naturalWidth;
        //const realHeight = myImg.naturalHeight;
        setW(realWidth);
      }
    }
    const img = document.createElement('img');
    img.id = tempId;
    img.src = src;
    img.onload = test;
    img.className = styles.tempImage;
    document.body.appendChild(img);
  }
  React.useEffect(() => {
    imgOriginalSize();
    return () => {
      const img = document.getElementById(tempId);
      document.removeChild(img);
    };
  }, []);
  React.useEffect(() => {
    if (w !== 0) {
      try {
        const img = document.getElementById(imageId);
        const width = img.clientWidth;
        const zoomRatio = w / width;
        zoomRatioRef.current = zoomRatio;
        if (focalValue) {
          updateFocalPoint({
            x: focalValue.x / zoomRatio,
            y: focalValue.y / zoomRatio,
          });
        }
      } catch (e) {
        if (focalValue) {
          updateFocalPoint({
            x: focalValue.x / 1,
            y: focalValue.y / 1,
          });
        }
      }
    }
  }, [w]);

  const updateFocalPoint = ({ x, y }) => {
    {
      setFocalPoint({
        x: x,
        y: y,
      });
      focalPointRef.current = {
        x: x,
        y: y,
      };
    }
  };

  const handleConfirm = () => {
    if (onOk) {
      const leftTop = {
        x: cropBox.x * zoomRatioRef.current,
        y: cropBox.y * zoomRatioRef.current,
      };
      const leftBottom = {
        x: cropBox.x * zoomRatioRef.current,
        y: (cropBox.y + cropBox.height) * zoomRatioRef.current,
      };
      const rightTop = {
        x: (cropBox.x + cropBox.width) * zoomRatioRef.current,
        y: cropBox.y * zoomRatioRef.current,
      };
      const rightBottom = {
        x: (cropBox.x + cropBox.width) * zoomRatioRef.current,
        y: (cropBox.y + cropBox.height) * zoomRatioRef.current,
      };

      onOk({
        value: {
          leftTop,
          leftBottom,
          rightBottom,
          rightTop,
        },
        focalValue: {
          x: focalPoint.x * zoomRatioRef.current,
          y: focalPoint.y * zoomRatioRef.current,
        },
      });
    }
  };

  // const handleLoadReady = () => {
  //   const imageElement: any = ref?.current;
  //   const cropper: any = imageElement?.cropper;
  //   let result = { left: 0, top: 0, width: 0, height: 0 };
  //   // setContainerOffset({
  //   //   x: containerRef.current.getBoundingClientRect().left,
  //   //   y: containerRef.current.getBoundingClientRect().top,
  //   // });
  //   const {
  //     width: imageWidth,
  //     naturalWidth,
  //     left: imageLeft,
  //     top: imageTop,
  //   } = cropper.getImageData();
  //   const zoomRatio = naturalWidth / imageWidth;
  //   zoomRatioRef.current = zoomRatio;
  //   imageRef.current = { left: imageLeft, top: imageTop };
  //   if (!value) {
  //     const { left, top, width, height } = cropper.getCropBoxData();
  //     result = { left, top, width, height };
  //     setCropBox({ width, height, x: left, y: top });
  //   } else {
  //     const left = value.leftTop.x / zoomRatio;
  //     const top = value.leftTop.y / zoomRatio;
  //     const width = value.rightTop.x / zoomRatio - left;
  //     const height = value.leftBottom.y / zoomRatio - top;
  //     setCropBox({ width, height, x: left, y: top });
  //     cropper.setCropBoxData({ left, top, width, height });
  //     result = { left, top, width, height };
  //   }
  //   if (focalValue) {
  //     updateFocalPoint({
  //       x: focalValue.x / zoomRatio,
  //       y: focalValue.y / zoomRatio,
  //     });
  //   } else {
  //     updateFocalPoint({
  //       x: result.left + PADDING + DEFAULT_OFFSET,
  //       y: result.top + DEFAULT_OFFSET,
  //     });
  //   }
  // };

  // const convertToCorrectRadio = (num) => {
  //   return num / 1; //zoomRatioRef.current;
  // };

  // useDebounceEffect(
  //   () => {
  //     const { x: _fX, y: fY } = focalPointRef.current;
  //      updateFocalPoint({
  //        x: result.left + PADDING + DEFAULT_OFFSET,
  //        y: result.top + DEFAULT_OFFSET,
  //      });
  //     const fX = _fX - PADDING;
  //     const { x, y, width, height } = cropBox;
  //     const xF = x;
  //     const xT = x + width - focusPointSize;
  //     const yF = y;
  //     const yT = y + height - focusPointSize;

  //     //console.log(xF, xT, yF, yT);

  //     if (width <= 40 && height <= 40) {
  //       setFocalPoint({
  //         x: convertToCorrectRadio(x),
  //         y: convertToCorrectRadio(y),
  //       });
  //       return;
  //     }
  //     if (fX < xF) {
  //       if (fY < yF) {
  //         //1
  //         console.log(1);
  //         updateFocalPoint({
  //           x: convertToCorrectRadio(xF + PADDING),
  //           y: convertToCorrectRadio(yF),
  //         });
  //         return;
  //       } else if (fY >= yF && fY <= yT) {
  //         //2
  //         console.log(2);
  //         updateFocalPoint({
  //           x: convertToCorrectRadio(xF + PADDING),
  //           y: fY,
  //         });
  //         return;
  //       } else {
  //         //3
  //         console.log(3);
  //         updateFocalPoint({
  //           x: convertToCorrectRadio(xF + PADDING),
  //           y: convertToCorrectRadio(yT),
  //         });
  //         return;
  //       }
  //     } else if (fX >= xF && fX <= xT) {
  //       if (fY < yF) {
  //         //4

  //         console.log(4);
  //         updateFocalPoint({
  //           x: _fX,
  //           y: convertToCorrectRadio(yF),
  //         });
  //         return;
  //       } else if (fY >= yF && fY <= yT) {
  //         //5
  //         console.log(5);
  //         return;
  //       } else {
  //         //6
  //         console.log(6);
  //         updateFocalPoint({
  //           x: _fX,
  //           y: convertToCorrectRadio(yT),
  //         });
  //         return;
  //       }
  //     } else {
  //       if (fY < yF) {
  //         //7
  //         console.log(7);
  //         updateFocalPoint({
  //           x: convertToCorrectRadio(xT + PADDING),
  //           y: convertToCorrectRadio(yF),
  //         });
  //         return;
  //       } else if (fY >= yF && fY <= yT) {
  //         //8
  //         console.log(8);
  //         updateFocalPoint({
  //           x: convertToCorrectRadio(xT + PADDING),
  //           y: fY,
  //         });
  //         return;
  //       } else {
  //         //9
  //         console.log(9);
  //         setFocalPoint({
  //           x: convertToCorrectRadio(xT + PADDING),
  //           y: convertToCorrectRadio(yT),
  //         });
  //         return;
  //       }
  //     }
  //   },
  //   [cropBox],
  //   { wait: 50 },
  // );

  // const handleCropMove = (e) => {
  //   const zoomRatio = zoomRatioRef.current;

  //   // const { x: _fX, y: fY } = focalPointRef.current;
  //   // const fX = _fX - PADDING;
  //   const { x, y, width, height } = e.detail;
  //   // const xF = x;
  //   // const xT = x + width; //- focusPointSize;
  //   // const yF = y;
  //   // const yT = y + height; //- focusPointSize;

  //   //console.log(xF, xT, yF, yT);
  //   setCropBox({
  //     x: x / zoomRatio,
  //     y: y / zoomRatio,
  //     width: width / zoomRatio,
  //     height: height / zoomRatio,
  //   });
  // };

  return (
    <Modal
      width={1080}
      visible={visible}
      onCancel={onCancel}
      onOk={onOk}
      title={getI18n('general.focalPointSetting')}>
      <div className={styles.container}>
        <div className={styles.leftContainer}>
          <div className={styles.left} ref={containerRef}>
            <img src={src} id={imageId} style={{ maxWidth: 1080 - 46 }} />
            {/* <Cropper
              movable={false}
              zoomable={false}
              crop={handleCropMove}
              ready={handleLoadReady}
              src={src}
              guides
              ref={ref}
            /> */}

            <Rnd
              size={{
                width: focusPointSize,
                height: focusPointSize,
              }}
              position={focalPoint}
              onDragStop={(e, d) => {
                updateFocalPoint({ x: d.x, y: d.y });
              }}
              maxHeight={focusPointSize}
              maxWidth={focusPointSize}
              scale={1}
              enableResizing={false}
              //cropper-crop-box cropper-container
              bounds={`#${imageId}`}>
              <div className={styles.hole}></div>
            </Rnd>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <Button onClick={onCancel} className={styles.button}>
          {getI18n('general.cancel')}
        </Button>
        <Button
          type={'primary'}
          onClick={handleConfirm}
          className={styles.button}>
          {getI18n('general.confirm')}
        </Button>
      </div>
    </Modal>
  );
}

export default ImageDisplaySetting;
